/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_UnpaidInputs */

const en_admin_dashboard_unpaid = /** @type {(inputs: Admin_Dashboard_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unpaid`)
};

const de_admin_dashboard_unpaid = /** @type {(inputs: Admin_Dashboard_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbezahlt`)
};

const es_admin_dashboard_unpaid = /** @type {(inputs: Admin_Dashboard_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por pagar`)
};

const fr_admin_dashboard_unpaid = /** @type {(inputs: Admin_Dashboard_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non payé`)
};

const nl_admin_dashboard_unpaid = /** @type {(inputs: Admin_Dashboard_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onbetaald`)
};

const it_admin_dashboard_unpaid = /** @type {(inputs: Admin_Dashboard_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non pagato`)
};

const pt_br2_admin_dashboard_unpaid = /** @type {(inputs: Admin_Dashboard_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em aberto`)
};

const pl_admin_dashboard_unpaid = /** @type {(inputs: Admin_Dashboard_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieopłacone`)
};

const hu_admin_dashboard_unpaid = /** @type {(inputs: Admin_Dashboard_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kifizetetlen`)
};

const ro_admin_dashboard_unpaid = /** @type {(inputs: Admin_Dashboard_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neplatit`)
};

/**
* | output |
* | --- |
* | "Unpaid" |
*
* @param {Admin_Dashboard_UnpaidInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_unpaid = /** @type {((inputs?: Admin_Dashboard_UnpaidInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_UnpaidInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_unpaid(inputs)
	if (locale === "de") return de_admin_dashboard_unpaid(inputs)
	if (locale === "es") return es_admin_dashboard_unpaid(inputs)
	if (locale === "fr") return fr_admin_dashboard_unpaid(inputs)
	if (locale === "nl") return nl_admin_dashboard_unpaid(inputs)
	if (locale === "it") return it_admin_dashboard_unpaid(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_unpaid(inputs)
	if (locale === "pl") return pl_admin_dashboard_unpaid(inputs)
	if (locale === "hu") return hu_admin_dashboard_unpaid(inputs)
	return ro_admin_dashboard_unpaid(inputs)
});
export { admin_dashboard_unpaid as "admin.dashboard.unpaid" }